import { render, staticRenderFns } from "./SwitchNijmegen.vue?vue&type=template&id=2e050274&"
import script from "./SwitchNijmegen.vue?vue&type=script&lang=js&"
export * from "./SwitchNijmegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports